export enum TemplateVersion {
    V2025_12_1 = '2025.12.1',
    V2026_01_1 = '2026.01.1',
    Latest = TemplateVersion.V2026_01_1,
}
